import {put, take, call} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import {
  showModalWindow,
  removeModalWindow
} from "../actions/WindowActions";
import {
  ACKNOWLEDGE_ERROR
} from "../actions/ViewActions";
import {stopAsyncValidation} from "redux-form/immutable";

export function* showErrorWindow(title, message) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ErrorWindow", {message: message}, title));
  yield take(ACKNOWLEDGE_ERROR);
  yield put(removeModalWindow(windowId));
}

export function* performApiLoadCall(apiMethod, data, actions) {
  yield put({type: actions.LOADING, data: data});
  const {response, error} = yield call(apiMethod, data);
  if (response) {
    yield put({type: actions.SUCCESS, entities: response.entities, result: response.result});
  } else {
    yield put({type: actions.FAILED, data: data, error: error});
  }
}

export function* performApiCallWithoutReponse(apiMethod, formData, actions, formName="") {
  yield put({type: actions.SUBMITTING, data: formData});
  const {response, error} = yield call(apiMethod, formData);
  if (response) {
    yield put({type: actions.SUCCESS, data: formData, response: response});
  } else {
    yield call(showErrorWindow, "An error occured", error.message);
    if (formName !== "") {
      let respondErrors = error.error;
      if (respondErrors.errors) respondErrors = respondErrors.errors;
      yield put(stopAsyncValidation(formName, respondErrors));
    }
    yield put({type: actions.FAILED, data: formData, error: error});
  }
}

